export const datosUsuario = () => {
  return {
    usuario: "",
    clave: "",
  };
};

export const datosSesion = () => {
  return {
    user: {
      username: "",
      ifip: {
        codigo: "",
        nombre: "",
        tipoEntidad: initTipoEntidadMS(),
      },
    },
    token: "",
    pantallas: null,
  };
};

export const initTipoEntidadMS = () => {
  return {
    codigo: "",
    agencias: "",
    estado: "",
    nombre: "",
    siglas: "",
    ventanilla: "",
    clave: "",
  };
};

export const casteoSesion = (usuario, mensaje) => {
  return {
    user: usuario.user,
    token: usuario.token,
    tokenRefresh: usuario.tokenRefresh,
    pantallas: usuario.pantallas,
  };
};
// ENTIDADES SOLICITUD DE CREDITO
export const DatosSocio = () => {
  return {
    codigo: "",
    codigoAgencia: "",
    codigoEntidad: "",
    codigoUsuarioActualiza: "",
    codigoUsuarioRegistra: "",
    fechaActualiza: "",
    fechaRegistro: "",
    estadoIngresoMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      descripcion: "",
      estado: "",
      fechaRegistro: "",
    },
    personaMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      codigoUsuarioActualiza: "",
      nombres: "",
      numeroIdentificacion: "",
      codigoIfip: "",
      correoElectronico: "",
      tipoIdentificacion: {
        codigo: "",
        nombre: "",
      },
      tipoPersona: {
        codigo: "",
        nombre: "",
      },
    },
    tipoRelacionMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      descripcion: "",
      estado: "",
      fechaRegistro: "",
    },
  };
};
export const initTipoViviendaMS = () => {
  const resultado = {
    codigo: "",
    descripcion: "",
  };
  return resultado;
};

export const initPersonMS = () => {
  const resultado = {
    codigo: "",
    numeroIdentificacion: "",
    nombres: "",
    tipoIdentificacion: InitTipoIdentificacionMS(),
    tipoPersona: InitTipoPersonaMS(),
    codigoUsuario: "",
  };
  return resultado;
};

export const initActividadEconomicaMS = () => {
  const resultado = {
    codigo: "",
    codigoEstructura: "",
    descripcionActividad: "",
    nivelActividad: "",
    estado: "",
    codigoTipoActividad: "",
    codigoActividadPadre: "",
    fechaRegistro: "",
    codigoUsuarioRegistra: "",
    codigUusuarioActualiza: "",
    fechaActualiza: "",
  };
  return resultado;
};
export const TipoProductoMs = () => {
  return {
    codigo: "",
    descripcion: "",
  };
};

export const initDatosBasicosMs = () => {
  const resultado = {
    codigoPersona: "",
    nombres: "",
    numeroIdentificacion: "",
    TipoPersonaMs: InitTipoPersonaMS(),
    TipoIdentificacionMs: InitTipoIdentificacionMS(),
    codigoEntidad: "",
    barrioComunidad: "",
    codigoDivisionPolitica: "",
    codigoTipoDireccion: "",
    direccion: "",
    fechaResidencia: "",
    referencia: "",
    sector: "",
    TipoViviendaMs: initTipoViviendaMS(),
    esPrincipal: "",
    estado: "",
    ActividadEconomicaMs: initActividadEconomicaMS(),
    codigoUsuarioActualiza: "",
    codigoUsuarioRegistra: "",
    fechaActualiza: "",
    fechaRegistro: "",
    fechaCaducidadIdentificacion: "",
    correoElectronico: "",
  };
  return resultado;
};
export const initPersonaNatural = () => {
  const resultado = {
    EstadoCivilMs: EstadoCivil(),
    GeneroMs: Genero(),
    DatosBasicosMs: initDatosBasicosMs(),
    NivelAcademicoMs: NivelAcademico(),
    ProfesionMs: {
      codigo: "",
      descripcion: "",
    },
  };
  return resultado;
};
export const initPersonCompletaMS = () => {
  const resultado = {
    codigoPersona: "",
    nombres: "",
    primerApellido: "",
    segundoApellido: "",
    numeroIdentificacion: "",
    correoElectronico: "",
    tipoPersona: InitTipoPersonaMS(),
    tipoIdentificacion: InitTipoIdentificacionMS(),
    codigoEntidad: "",
    barrioComunidad: "",
    codigoDivisionPolitica: "",
    codigoTipoDireccion: "",
    direccion: "",
    fechaResidencia: "",
    referencia: "",
    sector: "",
    tipoVivienda: initTipoViviendaMS(),
    esPrincipal: "S",
    estado: "A",
    actividadEconomicaMs: initActividadEconomicaMS(),
    codigoUsuarioActualiza: "",
    codigoUsuarioRegistra: "",
    fechaActualiza: "",
    fechaRegistro: "",
    fechaCaducidadIdentificacion: "",
    cargasFamiliares: "",
    conyuge: "",
  };
  return resultado;
};
export const iniInfoConyuge = () => {
  const resultado = {
    codigoPersona: '',
    nombres: '',
    primerApellido: '',
    segundoApellido: '',
    numeroIdentificacion: '',
    correoElectronico: '',
    TipoPersonaMs: InitTipoPersonaMS(),
    TipoIdentificacionMs: InitTipoIdentificacionMS(),
    codigoEntidad: '',
    fechaNacimiento: '',
    codigoUsuarioActualiza: '',
    codigoUsuarioRegistra: '',
    fechaActualiza: '',
    fechaRegistro: '',
    fechaCaducidadIdentificacion: '',
  };
  return resultado;
};


export const InitTipoIdentificacionMS = () => {
  const resultado = {
    codigo: "",
    descripcion: "",
    estado: "",
  };
  return resultado;
};
export const InitTipoPersonaMS = () => {
  const resultado = {
    codigo: "",
    descripcion: "",
    estado: "",
  };
  return resultado;
};

export const InitTipoUsuarioMS = () => {
  const resultado = {
    codigo: "",
    descripcion: "",
    estado: "",
  };
  return resultado;
};
export const initUsuarioMS = () => {
  return {
    codigo: "",
    clave: "",
    codigoUsuarioCreacion: "",
    correoElectronico: "",
    eliminado: "",
    estado: "",
    fechaCreacion: null,
    username: "",
    ifip: initTipoEntidadMS(),
    persona: initPersonMS(),
    tipoUsuario: InitTipoUsuarioMS(),
    usuarioRolMS: initUsuarioRolMS(),
  };
};

export const initUsuarioRolMS = () => {
  return {
    rolMs: initRolMS(),
    codigoUsuario: "",
    estado: "",
  };
};

export const initRolMS = () => {
  return {
    codigo: "",
    nombre: "",
    estado: "",
  };
};

export const initEntidadMS = () => {
  const resultado = {
    codigo: "",
    tipoEntidad: initTipoEntidadMS(),
    segmentoEntidad: initSegmentoEntiadadMS(),
    nombre: "",
    ruc: "",
    razonSocial: "",
    pathImagen: "",
    estado: "A",
    logoCentral: "",
    pathImagen1: "",
  };
  return resultado;
};

export const initSegmentoEntiadadMS = () => {
  return {
    codigo: "",
    segmento: "",
    nombre: "",
    descripcion: "",
    eliminado: "",
  };
};
export const CuentasSocio = () => {
  const resultado = {
    codigo: "",
    personMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      codigoUsuarioActualiza: "",
      nombres: "",
      numeroIdentificacion: "",
      tipoPersona: "",
      tipoIdentificacion: "",
      codigoIfip: "",
      correoElectronico: "",
    },
    saldoDisponible: "",
    saldoRestringido: "",
    saldoTotal: "",
    numeroCuenta: "",
    fechaInicial: null,
    fechaFinal: null,
  };
  return resultado;
};
export const Plazos = () => {
  const resultado = {
    codigo: "",
    plazo: "",
  };
  return resultado;
};
export const EstadoCivil = () => {
  const resultado = {
    codigo: "",
    nombre: "",
  };
  return resultado;
};
export const Genero = () => {
  const resultado = {
    codigo: "",
    nombre: "",
  };
  return resultado;
};
export const NivelAcademico = () => {
  const resultado = {
    codigo: "",
    nombre: "",
  };
  return resultado;
};
export const DivisionPolitica = () => {
  const resultado = {
    codigo: "",
    nombre: "",
  };
  return resultado;
};
export const PersonMs = () => {
  return {
    personMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      codigoUsuarioActualiza: "",
      nombres: "",
      numeroIdentificacion: "",
      tipoPersona: "",
      tipoIdentificacion: "",
      codigoIfip: "",
      correoElectronico: "",
    },
  };
};
export const DatosGarantes = () => {
  return {
    codigo: "",
    codigoAgencia: "",
    codigoEntidad: "",
    codigoUsuarioRegistra: "",
    estado: "",
    existeGarantiaOperacionCredito: "",
    fechaRegistra: "",
    numeroGarante: "",
    observacion: "",
    operacionCrediticiaMs: {
      actividadEconomicaMs: {
        codigo: "",
        codigo_actividad_padre: "",
        codigo_estructura: "",
        codigo_tipo_actividad: "",
        codigo_usuario_actualiza: "",
        codigo_usuario_registra: "",
        descripcion_actividad: "",
        estado: "",
        fecha_actualiza: "",
        fecha_registro: "",
        nivel_actividad: "",
      },
      codigo: "",
      valorTasa: "",
      numeroCuota: "",
      diasGracia: "",
      valorSolicitado: "",
      plazo: "",
      cuentaDestino: "",
      fechaRegistra: "",
      codigoUsuarioRegistra: "",
      observaciones: "",
      ingreMs: {
        codigo: "",
        nombre: "",
        ruc: "",
        razonSocial: "",
        pathImagen: "",
        estado: "",
        logoCentral: "",
        pathImagen1: "",
        organismoControl: {
          codigo: "",
          descripcion: "",
          estado: "",
          nombre: "",
          siglas: "",
        },
      },
      agenciaMs: {
        codigo: "",
        numero_autorizacion: "",
        punto_emision: "",
        nombre: "",
        estado: "",
        codigo_entidad: "",
        codigo_usuario_registra: "",
        fecha_registro: "",
        fecha_actualiza: "",
        codigo_usuario_actualiza: "",
      },
      ingresoPersonaMs: {
        codigo: "",
        codigoAgencia: "",
        codigoEntidad: "",
        codigoUsuarioActualiza: "",
        codigoUsuarioRegistra: "",
        fechaActualiza: "",
        fechaRegistro: "",
        estadoIngresoMs: {
          codigo: "",
          codigoUsuarioRegistra: "",
          descripcion: "",
          estado: "",
          fechaRegistro: "",
        },
        personaMs: {
          codigo: "",
          codigoUsuarioRegistra: "",
          codigoUsuarioActualiza: "",
          nombres: "",
          numeroIdentificacion: "",
          tipoPersona: {
            codigo: "",
            nombre: "",
          },
          tipoIdentificacion: {
            codigo: "",
            nombre: "",
          },
          codigoIfip: "",
          correoElectronico: "",
        },
        tipoRelacionMs: {
          codigo: "",
          codigoUsuarioRegistra: "",
          descripcion: "",
          estado: "",
        },
      },
    },
    personMs: {
      codigo: "",
      codigoIfip: "",
      codigoUsuarioActualiza: "",
      codigoUsuarioRegistra: "",
      correoElectronico: "",
      nombres: "",
      numeroIdentificacion: "",
      tipoIdentificacion: {
        codigo: "",
        nombre: "",
      },
      tipoPersona: {
        codigo: "",
        nombre: "",
      },
    },
    tipoGarante: "",
  };
};
export const DetalleCredito = () => {
  return {
    montoSolicitado: "",
    plazo: "",
    cuentaDestino: "",
  };
};

// Informacion para consulta de informacion de solicitud de credito
export const DatoSolicitudCredito = () => {
  return {
    codigo: "",
    valorTasa: 0,
    numeroCuota: "",
    diasGracia: "",
    valorSolicitado: "",
    plazo: "",
    cuentaDestino: "",
    fechaRegistra: "",
    codigoUsuarioRegistra: "",
    observaciones: "",
    ingreMs: {
      codigo: "",
      nombre: "",
      ruc: "",
      razonSocial: "",
      pathImagen: "",
      estado: "",
      logoCentral: "",
      pathImagen1: "",
      organismoControl: {
        codigo: "",
        descripcion: "",
        estado: "",
        nombre: "",
        siglas: "",
      },
    },
    agenciaMs: {
      codigo: "",
      numero_autorizacion: "",
      punto_emision: "",
      nombre: "",
      estado: "",
      codigo_entidad: "",
      codigo_usuario_registra: "",
      fecha_registro: "",
      fecha_actualiza: "",
      codigo_usuario_actualiza: "",
    },
    ingresoPersonaMs: {
      codigo: "",
      codigoAgencia: "",
      codigoEntidad: "",
      codigoUsuarioActualiza: "",
      codigoUsuarioRegistra: "",
      fechaActualiza: "",
      fechaRegistro: "",
      estadoIngresoMs: {
        codigo: "",
        codigoUsuarioRegistra: "",
        descripcion: "",
        estado: "",
        fechaRegistro: "",
      },
      personaMs: {
        codigo: "",
        codigoUsuarioRegistra: "",
        codigoUsuarioActualiza: "",
        nombres: "",
        numeroIdentificacion: "",
        tipoPersona: {
          codigo: "",
          nombre: "",
        },
        tipoIdentificacion: {
          codigo: "",
          nombre: "",
        },
        codigoIfip: "",
        correoElectronico: "",
      },
      tipoRelacionMs: {
        codigo: "",
        codigoUsuarioRegistra: "",
        descripcion: "",
        estado: "",
      },
    },
  };
};

export const IngresoPersonaMs = () => {
  return {
    codigo: "",
    codigoAgencia: "",
    codigoEntidad: "",
    codigoUsuarioActualiza: "",
    codigoUsuarioRegistra: "",
    fechaActualiza: "",
    fechaRegistro: "",
    estadoIngresoMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      descripcion: "",
      estado: "",
      fechaRegistro: "",
    },
    personaMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      codigoUsuarioActualiza: "",
      nombres: "",
      numeroIdentificacion: "",
      tipoPersona: {
        codigo: "",
        nombre: "",
      },
      tipoIdentificacion: {
        codigo: "",
        nombre: "",
      },
      codigoIfip: "",
      correoElectronico: "",
    },
    tipoRelacionMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      descripcion: "",
      estado: "",
    },
  };
};
export const initMovimientoMS = () => {
  const resultado = {
    valorCheque: 0,
    valorEfectivo: 0,
    valorSaldo: 0,
  };
  return resultado;
};
export const MovimientoMs = () => {
  return {
    codigo: "",
    codigoAgencia: "",
    codigoCanal: "",
    codigoUsuarioRegistra: "",
    codigoUsuarioActualiza: "",
    debitoCredito: "",
    nombreMaquina: "",
    observacion: "",
    valorCheque: "",
    valorEfectivo: "",
    valorSaldo: "",
    valorTransaccion: "",
    codigoProducto: "",
    codigoTransaccion: "",
    fechaActualiza: "",
    fechaRegistro: "",
    numeroCuenta: "",
    nombreTrasaccion: "",
    nombreProducto: "",
  };
};
export const SocioCredito = () => {
  const resultado = {
    codigo: "",
    personMs: {
      codigo: "",
      codigoUsuarioRegistra: "",
      codigoUsuarioActualiza: "",
      nombres: "",
      numeroIdentificacion: "",
      tipoPersona: "",
      tipoIdentificacion: "",
      codigoIfip: "",
      correoElectronico: "",
    },
    saldoDisponible: "",
    saldoRestringido: "",
    saldoTotal: "",
    numeroCuenta: "",
    fechaInicial: null,
    fechaFinal: null,
    numeroCredito: "",
    diasInteresCalculo: "",
    numeroCuota: "",
    fechaFinPago: "",
    fechaInicioPago: "",
    valorSaldo: "",
    valorCapital: "",
    valorInteres: "",
    valorPago: "",
  };
  return resultado;
};

export const InitTipoProductoMS = () => {
  const resultado = {
    codigo: "",
    descripcion: "",
    codigo_entidad: "",
    estado: "",
    codigo_usuario_registra: "",
    fecha_registra: "",
  };
  return resultado;
};

export const VerificaDatosGarante = () => {
  return {
    codigo: 0,
    codigoIfip: 0,
    codigoUsuarioActualiza: 0,
    codigoUsuarioRegistra: 0,
    correoElectronico: null,
    nombres: " ",
    numeroIdentificacion: " ",
    tipoIdentificacion: " ",
    tipoPersona: " ",
  };
};
